import React from "react";
import "./AnnualReport.scss";

const AnnualReport = () => {
  return (
    <div className="annual-report">
      <header className="report-hero">
        <div className="container">
          <h1>Milestone of the Bengaluru Law College</h1>
          <p className="lead">Presented by Dr. Devika S Ajila, Principal</p>
        </div>
      </header>

      <main className="container content">
        <section className="intro card">
          {/* <h2>Message from the Principal</h2>
          <p>
            It is with great pride and enthusiasm that I, <strong>Dr. Devika S
            Ajila</strong>, present the Annual Report of Bengaluru Law College,
            highlighting our academic achievements, service initiatives, and
            institutional progress over the past years.
          </p> */}
          <h2>Milestone</h2>
          <p>
            Since our establishment as <em>R.K. Law College</em> in 2009 and our
            transformation into <em>Bengaluru Law College</em> under the Law
            Wings Educational Trust in 2015, the institution has consistently
            upheld a tradition of academic excellence and community service.
          </p>
        </section>

        <section className="history card">
          <h2>History & Growth</h2>
          <p>
            Bengaluru Law College has a rich history of achievements and has
            continuously produced talented and socially responsible
            individuals. Our students have demonstrated outstanding performance
            in the Karnataka State Law University (KSLU) examinations, securing
            top ranks year after year.
          </p>

          <div className="ranks">
            <h3>Notable Rank Holders</h3>
            <ul>
              <li>Ravi C.S. – 3rd Rank (Kannada Medium, 2017 Batch)</li>
              <li>Laxmi Devi – 6th Rank (2018 Batch)</li>
              <li>Chaya Devi – 7th Rank (Kannada Medium, 2019 Batch)</li>
              <li>Swathi N. – 2nd Rank (2020 Batch)</li>
              <li>Divyashree – 5th Rank (English Medium, 2020 Batch)</li>
            </ul>
          </div>

          <p>
            In recognition of our commitment to academic excellence, Bengaluru
            Law College has been honoured to host the KSLU Valuation Center for
            the 8th consecutive time since 2022 and was recently recognised as
            a Revaluation Centre by the university — a testament to the
            credibility and trust our institution has earned.
          </p>
        </section>

        <section className="alumni card">
          <h2>Distinguished Alumni in Judiciary</h2>
          <ul>
            <li>Prakrthi Y R (2015 Batch) – Civil Judge, JMFC</li>
            <li>Shri Devadas H (2015 Batch) – Additional Civil Judge, Honnalli</li>
            <li>N. Narasimha Murthy – Additional Civil Judge, JMFC</li>
          </ul>
          <p>
            Their achievements inspire our current students and reinforce our
            commitment to nurturing future leaders in the legal field.
          </p>
        </section>

        <section className="community card">
          <h2>Community Engagement & NSS</h2>
          <p>
            Our NSS camps included blood donation drives collecting <strong>54
            units</strong> of blood, earning recognition as the highest blood
            donors in the constituency from the Karnataka Red Cross Society. The
            NSS Cell conducted academic and community-oriented initiatives,
            including career guidance programs, yoga instruction, legal awareness
            programs, surveys, and awareness through dramas and skits. The NSS
            unit also collaborated with local organisations for eye and dental
            checkups.
          </p>

          <p>
            In 2022, the college adopted Soladevanahalli and Avalakuppe villages
            in Nelamangala Taluk, conducting NSS camps, medical camps, street
            plays, and legal awareness programs. The college will provide free
            education for the entire 5-year BA LLB course to two meritorious
            students from the adopted villages who secure highest marks in PUC
            — extending our commitment to social responsibility.
          </p>
        </section>

        <section className="events card">
          <h2>Events, Workshops & Outreach</h2>

          <p>
            We organised a literacy programme with a cyber security workshop led
            by Shri Shivananda, collaborated with Vijaynagar Police Station on
            road safety awareness, and conducted legal awareness sessions for
            school students. Our students participated in the National Lok
            Adalat and received special appreciation from the District Legal
            Services Authority.
          </p>

          <p>
            Special days observed include World Environment Day (biodiversity
            lecture by K.C. Singh), No Tobacco Day (awareness jatha),
            International Yoga Day (session by Yoga Guru Prasanna V. Raju), and
            Women’s Day (felicitations for women achievers).
          </p>

          <p>
            The college hosted a Human Rights workshop in collaboration with
            SHRC and KSLSA, with distinguished judicial dignitaries in
            attendance. We also organised programs on NDPS Act by Dr.
            Raviprakash and participated in police community initiatives,
            securing 4th place for assisting police in traffic management.
          </p>
        </section>

        <section className="culture card">
          <h2>Culture, Fests & Sports</h2>
          <p>
            Our annual cultural fest <strong>Tarang</strong> showcased traditional
            and modern art forms, performing arts, and was inaugurated by
            renowned artists such as Sri Niranjan Deshpande, Sri Lokesh Kumar,
            Sri Ambarish Sarangi, and Sri Usha Bhandary.
          </p>

          <p>
            Our inter-class sports meet <strong>Khel</strong> was inaugurated by
            Miss Pallavi Chandra, and featured track and field events along with
            team sports like kabaddi — promoting teamwork, fitness, and
            sportsmanship.
          </p>
        </section>

        <section className="library card">
          <h2>Library & Learning Resources</h2>
          <p>
            The college library is a comprehensive resource hub with more than
            <strong> 10,775 books</strong> including law reports, journals, Bare
            Acts, and over a thousand reference books. Subscriptions to online
            platforms such as CDJ and other e-resources provide instant access
            to the latest judgments and advanced legal research tools.
          </p>
        </section>

        <section className="achievements card">
          <h2>Recognitions & Academic Highlights</h2>
          <p>
            Bengaluru Law College was recognised as the <em>Best Legal Services
            Clinic</em> at the Kanoonu Santhe organised by Ramaiah College of Law
            in collaboration with KSLU in 2022. The college celebrated
            Graduation Day with Hon’ble Justice Ashok G Nijagannanavar.
          </p>

          <p>
            We organised a National Seminar on Probity in Governance and
            conducted a national-level essay competition to commemorate the
            75th anniversary of India's independence.
          </p>

          <p>
            The college has been granted affiliation from KSLU and approval from
            the Bar Council of India (BCI) to offer the 3-Year LL.B. Degree
            Programme with 2 additional sections.
          </p>

          <ul>
            <li>Qualified and dedicated faculty members</li>
            <li>Well-equipped classrooms and Moot Court Hall</li>
            <li>Rich law library with journals and e-resources</li>
            <li>Student-focused academic and co-curricular activities</li>
          </ul>
        </section>

        <section className="closing card">
          <h2>Closing Note</h2>
          <p>
            The past year stands as a testimony to the academic growth, resilience,
            and dedication of Bengaluru Law College. We express our gratitude to
            the management, faculty, non-teaching staff, parents, alumni, and
            well-wishers for their constant support.
          </p>

          <p>
            As we step into the new academic year, we look forward to greater
            milestones, stronger collaborations, and continued dedication to
            shaping skilled, compassionate, and responsible individuals. With
            renewed optimism, we pledge to carry forward the legacy of Bengaluru
            Law College and strive for excellence in every sphere of education.
          </p>
        </section>
      </main>

      <footer className="report-footer">
        <div className="container">
          <p>© Bengaluru Law College • Law Wings Educational Trust</p>
        </div>
      </footer>
    </div>
  );
};

export default AnnualReport;


